import { render, staticRenderFns } from "./expediente.view.vue?vue&type=template&id=0d216af7"
import script from "./expediente.view.vue?vue&type=script&lang=js"
export * from "./expediente.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports